<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="status flex"  :class="state | status_color" v-if="state !== -1">
            <div class="text-sm text-white">{{state | status}}</div>
            <div class="text-sm margin-left-xs text-white" v-if="state === 2">{{reason}}</div>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <el-table
                v-loading="loading"
                :data="lists"
                :span-method="objectSpanMethod"
                border
                header-row-class-name="table-header"
                show-summary
                style="width: 100%">
                <el-table-column label="一级指标" prop="one_name">
                    <template slot-scope="scope">
                        <div class="table-item text-bold">
                            {{ scope.row.one_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="一级指标权重赋分" prop="one_score" width="180">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <el-input v-model.number="scope.row.one_score" disabled type="number"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="二级指标" prop="two_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.two_id)">
                            {{ scope.row.two_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="二级指标权重赋分" prop="two_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.two_id" class="table-item">
                            <el-input v-model.number="scope.row.two_score" placeholder="请输入" type="number" disabled @input="inputChange(scope.row.one_id,'one_id','two_score','one_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="三级指标" prop="three_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.three_id)">
                            {{ scope.row.three_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="三级指标权重赋分" prop="three_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.three_id" class="table-item">
                            <el-input v-model.number="scope.row.three_score" placeholder="请输入" type="number" disabled @input="inputChange(scope.row.two_id,'two_id','three_score','two_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="四级指标" prop="four_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.four_id)">
                            {{ scope.row.four_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="四级指标权重赋分" prop="four_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.four_id" class="table-item">
                            <el-input v-model.number="scope.row.four_score" placeholder="请输入" type="number" disabled @input="inputChange(scope.row.three_id,'three_id','four_score','three_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="flex align-center justify-center margin-top" v-if="!readonly">
                <el-button class="btn max bg-red radius " type="danger" @click="submitApply(false)">
                    驳回
                </el-button>
                <el-button class="btn max bg-green radius margin-left-xl" type="success" @click="submitApply(true)">
                    通过
                </el-button>
            </div>
        </div>
        <task-detail-task-dialog :dialog-visible="addTaskDialog" :tid="cur_task_id" :readonly="true" @watchDetailState="watchDetailState"></task-detail-task-dialog>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`拒绝原因`"
            :visible.sync="addReasonDialog"
            center
            width="400px">
            <el-form class="publish-form"  ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label-width="0" prop="reason">
                    <el-input v-model="ruleForm.reason" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import {applyExTaskScore, getTaskScoreEx} from "@/api";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";
import {confirm, TOAST, toast} from "@/utils/utils";

export default {
    name: "task-assignment",
    components: {TaskDetailTaskDialog},
    data() {
        return {
            pid: 0,
            log_id: 0,
            pname: '',
            lists: [],
            loading: false,
            cur_task_id: 0,
            cur_task_sid: 0,
            addTaskDialog: false,
            column_1: [],
            pos_1: 0,
            column_2: [],
            pos_2: 0,
            column_3: [],
            pos_3: 0,
            column_4: [],
            pos_4: 0,
            state:-1, //0 审核中 1 审核通过 2 拒绝
            reason:'',
            ruleForm: {
                reason: '',
            },
            rules: {
                reason: [
                    {required: true, message: '请输入拒绝原因', trigger: 'change'}
                ]
            },
            addReasonDialog: false,
            readonly: true,
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.pname = this.$route.params.title
        this.$emit('setIndex', [1,3], `${this.pname}- 权重赋分`, true)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        inputChange(_id,cur_id,cur_score,score) {
            let _item = this.lists.find(f => {
                return _id === f[cur_id]
            })
            let _index = this.lists.findIndex(f => {
                return _id === f[cur_id]
            })
            this.lists[_index][score]= this.lists.filter(f => {
                return _id === f[cur_id]
            }).reduce((pre, next) => {
                return pre + (Number(next[cur_score] || 0))
            }, 0)
            if (cur_id === 'two_id') this.inputChange(_item.one_id,'one_id','two_score','one_score')
            if (cur_id === 'three_id') this.inputChange(_item.two_id,'two_id','three_score','two_score')
        },
        async submitApply(data) {
            if (data) {
                confirm(`提示`, `你确定通过${this.pname}权重赋分嘛？`, () => {
                    this.submitInfo(1)
                }, '确认', true)
            }else{
                this.addReasonDialog = true
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitInfo(2,this.ruleForm.reason)
                }
            });
        },
        async submitInfo(state,reason = '') {
            let _data = await applyExTaskScore(this.log_id,state,reason)
            if (_data.status === 200) {
                toast(`审核成功`, TOAST.success)
                this.$router.go(-1)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        cancel() {
            this.addReasonDialog = false
        },
        async init() {
            let _data = await getTaskScoreEx(this.pid, )
            if ( _data.data.log){
                this.log_id = _data.data.log.id
                this.state = _data.data.log.state
                this.reason = _data.data.log.reason || ''
                this.readonly = this.state === 1 || this.state === 2
            }
            _data.data.list.map((item) => {
                if (item.children.length === 0) {
                    this.lists.push(this.customData(item.id, item.name, Number(item.score || 0)))
                } else {
                    item.children.map((two,two_index) => {
                        if (two.children.length === 0) {
                            this.lists.push(this.customData(item.id, item.name, Number(two_index === 0 ? (item.score || 0) : 0), two.id, two.name, Number(two.score || 0)))
                        } else {
                            two.children.map((three,three_index) => {
                                if (three.children.length === 0) {
                                    this.lists.push(this.customData(item.id, item.name,  Number(two_index + three_index  === 0 ? (item.score || 0) : 0), two.id, two.name, Number(three_index === 0 ? (two.score || 0) : 0), three.id, three.name, Number(three.score||0)))
                                } else {
                                    three.children.map((four,four_index) => {
                                        this.lists.push(this.customData(item.id, item.name,  Number(two_index + three_index + four_index === 0 ? (item.score || 0) : 0), two.id, two.name, Number(three_index + four_index === 0 ? (two.score || 0) : 0), three.id, three.name, Number(four_index === 0 ? (three.score || 0) : 0), four.id, four.name, Number(four.score)))
                                    });
                                }
                            })
                        }

                    })
                }
            })
            this.getSpanArr(this.lists)
            this.loading = false
        },
        customData(one_id, one_name, one_score, two_id = '', two_name = '--', two_score = '', three_id = '', three_name = '--', three_score = '', four_id = '', four_name = '--', four_score = '') {
            return {
                one_id,
                one_name,
                one_score,
                two_id,
                two_name,
                two_score,
                three_id,
                three_name,
                three_score,
                four_id,
                four_name,
                four_score
            }
        },
        getSpanArr(data) {
            this.column_1 = []
            this.column_2 = []
            this.column_3 = []
            this.column_4 = []
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    this.column_1.push(1);
                    this.column_2.push(1);
                    this.column_3.push(1);
                    this.column_4.push(1);
                    this.pos_1 = 0
                    this.pos_2 = 0
                    this.pos_3 = 0
                    this.pos_4 = 0
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i].one_id === data[i - 1].one_id) {
                        this.column_1[this.pos_1] += 1;
                        this.column_1.push(0);
                    } else {
                        this.column_1.push(1);
                        this.pos_1 = i;
                    }
                    if (data[i].two_id === data[i - 1].two_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_2[this.pos_2] += 1;
                        this.column_2.push(0);
                    } else {
                        this.column_2.push(1);
                        this.pos_2 = i;
                    }
                    if (data[i].three_id === data[i - 1].three_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_3[this.pos_3] += 1;
                        this.column_3.push(0);
                    } else {
                        this.column_3.push(1);
                        this.pos_3 = i;
                    }
                    if (data[i].four_id === data[i - 1].four_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_4[this.pos_4] += 1;
                        this.column_4.push(0);
                    } else {
                        this.column_4.push(1);
                        this.pos_4 = i;
                    }
                }
            }
        },
        objectSpanMethod({rowIndex, columnIndex}) {
            if (columnIndex === 0 || columnIndex === 1) {
                const _row = this.column_1[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 2 || columnIndex === 3) {
                const _row = this.column_2[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 4 || columnIndex === 5) {
                const _row = this.column_3[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else {
                const _row = this.column_4[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        addTask(data) {
            if (!data) return
            this.cur_task_id = data
            this.addTaskDialog = true
        },
        watchDetailState() {
            this.cur_task_id = 0
            this.addTaskDialog = false
        }

    },
    filters: {
        status(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 :
                    return '审核中'
                case 1 :
                    return '已通过'
                case 2 :
                    return '已拒绝：'
            }
        },
        status_color(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 :
                    return 'bg-orange'
                case 1 :
                    return 'bg-green'
                case 2 :
                    return 'bg-red'
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .status{
        padding: 12px 24px;
    }
}
</style>
